import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ISCDUserDto } from '@shared/interfaces/user/ISCDUser';
import { MatDialog } from '@angular/material/dialog';
import { ScdExternDialogComponent } from '@shared/components/scd-extern-dialog/scd-extern-dialog.component';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'app-user-picker',
    templateUrl: './user-picker.component.html',
    styleUrls: ['./user-picker.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => UserPickerComponent),
            multi: true
        }
    ],
    standalone: false
})
export class UserPickerComponent implements ControlValueAccessor {
    @Input() placeholder: string;
    @Input() value: ISCDUserDto;
    @Input() readonly: boolean;
    @Input() required: boolean;

    @Output()
    selected = new EventEmitter<ISCDUserDto | ISCDUserDto[]>();

    constructor(private dialog: MatDialog) {}

    writeValue(value: any) {
        if (value !== undefined) {
            this.value = value;
        }
    }

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {
        /* Form control touched handler */
    }

    propagateChange = (_: any) => {
        // ControlValueAccessor callback placeholder
    };

    openEmployeeSelection() {
        this.dialog
            .open(ScdExternDialogComponent, {
                disableClose: true,
                position: { top: '50px' },
                data: {
                    users: this.value
                },
                panelClass: 'custom-dialog',
                backdropClass: 'transparent-backdrop'
            })
            .afterClosed()
            .subscribe(selected => {
                this.value = selected;
                this.propagateChange(this.value);
            });
    }

    removeSelected() {
        this.value = null;
        this.propagateChange(this.value);
    }
}
